// the return output after login. I know it is a state, but we need this specific type to be returned
// in multiple functions.
export class UserSession {
  username: string | null = null;
  accessToken: string | null = null;
  xsrfToken: string | null = null;

  constructor(username: string | null, accessToken: string | null, xsrfToken: string | null = null) {
    this.username = username;
    this.accessToken = accessToken;
    this.xsrfToken = xsrfToken;
  }
}
